import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWebmoneyComponent } from './simple-icons-webmoney.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWebmoneyComponent ],
    exports:      [ SimpleIconsWebmoneyComponent ],
    bootstrap:    []
})
export class SimpleIconsWebmoneyModule {}
